import { jsxs, jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import '../LoadingPlaceholder/index.js';
import { LoadingPlaceholder } from '../LoadingPlaceholder/LoadingPlaceholder.js';

const LoadingWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex: 1;
`;
const StyledMessageContainer = styled.div `
  position: absolute;
  margin-top: 64px;
`;
const LoadingState = ({ message }) => (jsxs(LoadingWrapper, { children: [jsx(LoadingPlaceholder, { size: "64px" }), message && jsx(StyledMessageContainer, { children: message })] }));

export { LoadingState };
